import { type ReactNode } from "react";

interface Props {
  eyebrow: string;
  title: string;
  detail?: string;
  action?: ReactNode;
  children: ReactNode;
}

export function Section({ eyebrow, title, detail, action, children }: Props) {
  return (
    <section className="mt-12 first:mt-0">
      <header className="mb-5 flex items-end justify-between gap-6">
        <div className="min-w-0">
          <p className="label-eyebrow">{eyebrow}</p>
          <h2 className="mt-1.5 font-display text-xl tracking-tight">{title}</h2>
          {detail && <p className="mt-1 text-xs text-whisper max-w-md">{detail}</p>}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </header>
      {children}
    </section>
  );
}
